<app-masterpage>
</app-masterpage>
<div class="page-wrapper">
    <app-header>
    </app-header>
    <div class="container-fluid pt-custom">
        <div class="row">
            <div class="col-lg-12 col-md-12 col-12">
                <div style="display: flex; align-items: center;justify-content: space-between;" class="py-2">
                    <h4 class="custom-font"> Registration Detail Request List</h4>
                    <!-- <button class="btn btn-success custom-font" type="button" style="margin: 5px;"
                        (click)="addNew()">Add
                        New Registration</button> -->
                </div>
            </div>
        </div>
        <div class="card row">
            <div class=" col-lg-12 col-md-12 col-12 p-4">
                <div class="row">
                    <div class="col-md-11">
                        <div class="py-3">
                            <input type="text" id="searchtext"
                                class="form-control bg-white border-0 small"
                                placeholder="Search for..." [(ngModel)]="searchtext"
                                aria-label="Search" aria-describedby="basic-addon2" />
                        </div>
                    </div>
                    <div class="col-md-1">
                        <div class="py-3">
                            <button class="btn btn-success"
                                (click)="GetRegistrationRequestList(1);"
                                style="margin: 5px;">Search</button>
                        </div>
                    </div>
                </div>
                <div class="table-responsive">
                    <table id="example" class="table table-striped table-bordered" style="width:100%">
                        <thead>
                            <tr>
                                <!-- <th class="pointer"(click)="sortBy('Board')">Name</th> -->
                                <th class="pointer" scope="col" (click)="sortBy('SrNo')">Sr. No.</th>
                                <th class="pointer" scope="col" (click)="sortBy('RequestDate')">Request Date</th>
                                <th class="pointer" scope="col" (click)="sortBy('SchoolName')">College Name</th>
                                <th class="pointer" scope="col" (click)="sortBy('CollegeCode')">College Code</th>
                                <th class="pointer" scope="col" (click)="sortBy('Board')"> Board </th>
                                <th class="pointer" scope="col" (click)="sortBy('Medium')">Medium</th>
                                <!-- <th class="pointer" scope="col" (click)="sortBy('Office')">Office</th> -->
                                <th class="pointer" scope="col" (click)="sortBy('TypeOfTrust')">Type Of Trust</th>
                                <th class="pointer" scope="col" (click)="sortBy('Section')">Section</th>
                                <th class="pointer" scope="col" (click)="sortBy('SchoolMailID')">College Mail ID</th>
                                <th class="pointer" scope="col" (click)="sortBy('Status')">Status</th>
                                <th class="pointer" scope="col">Action</th>
                            </tr>
                        </thead>
                        <tbody *ngIf="registrationlist != undefined && registrationlist.length > 0" style="font-size: small;">
                            <tr *ngFor="let r of registrationlist | paginate: { itemsPerPage: pageLimit,currentPage: p ,totalItems: totalRequest};let i = index">
                                <td>{{r.SrNo}}</td>
                                <td>
                                    <p>{{r.RequestDate}}</p>
                                </td>
                                <td>
                                    <p>{{r.SchoolName}}</p>
                                </td>
                                <td>
                                    <p>{{r.CollegeCode}}</p>
                                </td>
                                <td>
                                    <p>{{r.Board}}</p>
                                </td>
                                <td width='15%'>
                                    <p>{{r.Medium}}</p>
                                </td>
                                <!-- <td>
                                    <p>{{r.Office}}</p>
                                </td> -->
                                <td>
                                    <p>{{r.TypeOfTrust}}</p>
                                </td>
                                <td>
                                    <p>{{r.Section}}</p>
                                </td>
                                <td>
                                    <p>{{r.SchoolMailID}}</p>
                                </td>
                                <td>
                                    <div *ngIf="r.Status == 0;">
                                        <span class="badge badge-primary" style="font-size: larger;">Pending</span>
                                    </div>
                                    <div *ngIf="r.Status == 1;">
                                        <span class="badge badge-success" style="font-size: larger;">Approved</span>
                                    </div>
                                    <div *ngIf="r.Status == 2;">
                                        <span class="badge badge-danger" style="font-size: larger;">Rejected</span>
                                    </div>
                                </td>
                                <td style="white-space: nowrap;">
                                    <div class="dropdown">
                                        <button type="button" class="btn btn-success rmb_10" *ngIf="r.Status == 0;"
                                        (click)="editRegistration(r.HashCode)">View</button>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                        <tbody *ngIf="registrationlist == undefined || registrationlist.length == 0">
                            <tr>
                                <td colspan="11" style="text-align: center;">
                                    No Record Found
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="card-footer pb-3 pt-3 mb-4" align="center">
                    <pagination-controls (pageChange)="GetRegistrationRequestList($event)" responsive="true"
                    maxSize="{{totalPages}}"></pagination-controls>
                </div>
            </div>
        </div>
    </div>
    <div class="footer-login custom-footer">
        <p class="mb-0">Copyright © Netsol IT Solution Pvt. Ltd. 2020 All Rights Reserved</p>
        <img src="assets/images/powered-by.png" alt="netsol-powerd by" class="img-fluid">
    </div>
    <ngx-spinner bdcolor="rgba(51, 51, 51, 0.8)" size="default" type="ball-spin-clockwise">
        <p style="color: white;">Please Wait.</p>
    </ngx-spinner>
</div>